import React from 'react';

function HourlyBar({ hourlyData, daily }) {
  if (!hourlyData || hourlyData.length === 0) {
    return null;
  }

  return (
    <div className="hourly-section-wrapper">
      <div className="hourly-header">
        <h3>24-Hour Forecast</h3>
        <span className="hourly-subtitle">Hourly Conditions</span>
      </div>
      
      <div className="hourly-bar">
        {hourlyData.map((hour, i) => {
          const date = new Date(hour.startTime);
          const time = date.toLocaleTimeString([], { 
            hour: 'numeric', 
            hour12: true 
          });
          
          const now = new Date();
          const isNow = Math.abs(date - now) < 30 * 60 * 1000;
          const windSpeed = hour.windSpeed ? hour.windSpeed.split(' ').slice(-2).join(' ') : '';

          let effectiveIsDay = hour.isDaytime;
          try {
            if (daily && Array.isArray(daily.time) && Array.isArray(daily.sunrise) && Array.isArray(daily.sunset)) {
              const localDayKey = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
              const dayIndex = daily.time.findIndex((day) => day === localDayKey);

              if (dayIndex !== -1) {
                const sunriseDate = new Date(daily.sunrise[dayIndex]);
                const sunsetDate = new Date(daily.sunset[dayIndex]);
                effectiveIsDay = date >= sunriseDate && date < sunsetDate;
              }
            }
          } catch (e) {
            effectiveIsDay = hour.isDaytime;
          }

          const adjustIconForDayNight = (iconUrl, isDay) => {
            if (!iconUrl) return iconUrl;
            try {
              if (iconUrl.includes('/day/')) return isDay ? iconUrl : iconUrl.replace('/day/', '/night/');
              if (iconUrl.includes('/night/')) return isDay ? iconUrl.replace('/night/', '/day/') : iconUrl;
              return iconUrl;
            } catch (e) {
              return iconUrl;
            }
          };

          const displayIcon = adjustIconForDayNight(hour.icon, effectiveIsDay);

          return (
            <div key={i} className={`hourly-item ${isNow ? 'hourly-item-now' : ''}`}>
              <div className="hourly-time">
                {isNow ? 'Now' : time}
              </div>
              <img 
                src={displayIcon} 
                alt={hour.shortForecast} 
                className="hourly-icon" 
              />
              <div className="hourly-temp">{hour.temperature}°</div>
              <div className="hourly-condition">{hour.shortForecast}</div>
              {windSpeed && (
                <div className="hourly-wind">
                  <span className="wind-icon">💨</span> {windSpeed}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default HourlyBar;